import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../core/services/auth.service';
import { LanguageService } from '../../../core/services/language.service';
import { emailOrUsernameValidator } from '../../../shared/validators/email-or-username.validator';
import { LoadingComponent } from '../../../shared/components/loading/loading.component';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-login',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    LoadingComponent,
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent implements OnInit {
  loginForm!: FormGroup;
  submitted = false;
  showPassword = false;
  currentYear: number = new Date().getFullYear();
  isSubmitting = false;
  loading$!: Observable<boolean>;
  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
    public languageService: LanguageService
  ) {
    this.loading$ = this.languageService.loading$;
  }

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      username: ['admin@altkamul.ae', [emailOrUsernameValidator]],
     password: [
  '',
  [
    Validators.required,
    Validators.minLength(8),
    Validators.pattern(/^(?=.*[A-Z])(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/)
  ]
],  
    });
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
  }

  hasError(controlName: string, errorType?: string): boolean {
    const control = this.loginForm.get(controlName);
    if (!control) return false;
    if (!errorType)
      return control.invalid && (control.touched || this.submitted);
    return control.hasError(errorType) && (control.touched || this.submitted);
  }

onLogin() {
  this.submitted = true;
  if (this.loginForm.invalid) return;

  this.isSubmitting = true;

  this.authService.login(this.loginForm.value).subscribe({
    next: (res) => {
      this.isSubmitting = false;

      if (res?.isSuccess) {
        this.router.navigate(['/dashboard']);
      } else {
        alert('Login failed');
      }
    },
    error: () => {
      this.isSubmitting = false;
      alert('Login failed');
    },
  });
}

}
